import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffChangePasswordModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffChangePasswordModalContainer" */
      './StaffChangePasswordModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
